/**
 * RAPOR PARA BİRİMİ — seçenekler ve KALICI tercih (01.10.2026, kullanıcı).
 *
 * Eskiden seçim `ReportScreen` içinde bir `useState("TRY")`ydı: sayfa her
 * açıldığında TRY'ye dönüyordu. Artık son seçim hatırlanıyor — tema gibi
 * `localStorage`da (`ThemeProvider` ile aynı desen): bu bir SUNUM tercihi,
 * portföy verisi değil, defterle birlikte yedeklenmesi ya da cihazlar arasında
 * taşınması gerekmiyor. Depolama kapalıysa (gizli pencere) tercih oturumla
 * sınırlı kalır ve rapor TRY ile açılır — veri kaybı değil.
 *
 * LİSTE SABİT ve kısa, kodları sözleşmede TEK yerde (`RAPOR_PARA_BIRIMLERI`,
 * yalnızca TCMB bülteninde olan birimler; 27.10.2026). Defterden türetilmiş
 * bir liste, hiç kuru olmayan bir
 * para biriminde rapor istemeyi kolaylaştırırdı. Vergi TRY'de; ötekiler
 * karşılaştırma için. Eşitleme bu listenin HER kodu için `[kod, TRY]` kurunu
 * da çeker (`esitlemeHedefi.ts`) — yoksa defterde hiç USD satırı yokken USD
 * raporu "TRY/USD kuru yok" derdi.
 */

import type { CurrencyCode } from "@parafon/contracts";
import { RAPOR_PARA_BIRIMLERI as RAPOR_PARA_KODLARI } from "@parafon/contracts";
import { paraBirimiAdi } from "./format";

/** Seçici seçenekleri: kodlar sözleşmedeki TEK listeden, ad dilin yerleşik adı. */
export const RAPOR_PARA_BIRIMLERI: readonly { readonly value: CurrencyCode; readonly label: string }[] =
  RAPOR_PARA_KODLARI.map((kod) => ({ value: kod, label: `${kod} — ${paraBirimiAdi(kod)}` }));

export const VARSAYILAN_RAPOR_PARA_BIRIMI: CurrencyCode = "TRY";

export const RAPOR_PARA_ANAHTARI = "parafon.raporParaBirimi";

function listede(kod: string): boolean {
  return RAPOR_PARA_BIRIMLERI.some((c) => c.value === kod);
}

/** Saklanan tercih; yoksa, bozuksa ya da depolama kapalıysa TRY. */
export function kayitliRaporParaBirimi(): CurrencyCode {
  try {
    const v = globalThis.localStorage?.getItem(RAPOR_PARA_ANAHTARI);
    return typeof v === "string" && listede(v) ? v : VARSAYILAN_RAPOR_PARA_BIRIMI;
  } catch {
    return VARSAYILAN_RAPOR_PARA_BIRIMI;
  }
}

export function raporParaBiriminiKaydet(kod: CurrencyCode): void {
  if (!listede(kod)) return;
  try {
    globalThis.localStorage?.setItem(RAPOR_PARA_ANAHTARI, kod);
  } catch {
    // Depolama kapalı: tercih oturumla sınırlı — kabul edilebilir.
  }
}

/**
 * GRAFİĞİN PARA BİRİMİ (12.10.2026, kullanıcı: "seçilen para birimi ile
 * (USD)"). Rapordan AYRI bir tercih ve varsayılanı USD; liste ve doğrulama
 * aynı.
 */
export const VARSAYILAN_GRAFIK_PARA_BIRIMI: CurrencyCode = "USD";
export const GRAFIK_PARA_ANAHTARI = "parafon.grafikParaBirimi";

export function kayitliGrafikParaBirimi(): CurrencyCode {
  try {
    const v = globalThis.localStorage?.getItem(GRAFIK_PARA_ANAHTARI);
    return typeof v === "string" && listede(v) ? v : VARSAYILAN_GRAFIK_PARA_BIRIMI;
  } catch {
    return VARSAYILAN_GRAFIK_PARA_BIRIMI;
  }
}

export function grafikParaBiriminiKaydet(kod: CurrencyCode): void {
  if (!listede(kod)) return;
  try {
    globalThis.localStorage?.setItem(GRAFIK_PARA_ANAHTARI, kod);
  } catch {
    // Depolama kapalı: tercih oturumla sınırlı.
  }
}
